import { Controller } from "@hotwired/stimulus";

export class GalleryController extends Controller {
  static targets = ["tile", "wrap", "grid", "workItem", "workDetail"];

  connect() {
    this.navbar = document.querySelector("nav.navbar");
    this.openId = null;
    this.revealListener = () => this.reveal();
    this.element.addEventListener("turbo:frame-render", this.revealListener);
    const navH = this.navbar?.offsetHeight || 0;
    const topMargin = -navH;
    const bottomMargin = -(window.innerHeight - navH - 1);
    this.observer = new IntersectionObserver(
      (entries) => this.onIntersect(entries),
      { rootMargin: `-30% 0px -30% 0px` },
    );
    this.tileTargets.forEach((tile) => {
      this.observer.observe(tile);
    });
  }
  disconnect() {
    this.observer?.disconnect();
    window.removeEventListener("turbo:frame-render", this.revealListener);
  }
  onIntersect(entries) {
    entries.forEach((entry) => {
      entry.target.classList.toggle("in-view", entry.isIntersecting);
    });
  }
  closeGallery(event) {
    event.preventDefault();
    this.wrapTarget.classList.remove("is-open");

    this.workItemTargets.forEach((el) => el.classList.remove("in"));
    this.clearSelected();
    this.openId = null;
  }
  tileClick(event) {
    const id = event.currentTarget.dataset.workId;

    if (id === this.openId) {
      this.closeGallery(event);
      return;
    }
    this.pendingId = id;
  }


  async reveal() {
    this.workItemTargets.forEach((el, i) => {
      el.style.transitionDelay = `${i * 90}ms`;
      requestAnimationFrame(() => el.classList.add("in"));
    });
    this.wrapTarget.classList.add("is-open");
    this.openId = this.pendingId;
    this.markSelected();

    if (!this.hasWorkDetailTarget) return;
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
    await sleep(420);
    this.workDetailTarget.scrollIntoView();
  }

  markSelected() {
    this.tileTargets.forEach((t) => {
      t.classList.toggle("selected", t.dataset.workId === this.openId);
      t.classList.toggle("unselected", t.dataset.workId !== this.openId);
    });
  }

  clearSelected() {
    this.tileTargets.forEach((t) => t.classList.remove("selected"));
    this.tileTargets.forEach((t) => t.classList.remove("unselected"));
  }
}
